import React from "react";
import { Fade } from "react-slideshow-image";
import "./Slides.css";

const FadeExample = () => {
  const properties = {
    duration: 3000,
    transitionDuration: 2000,
    infinite: true,
    prevArrow: (
      <div style={{ width: "0", marginRight: "0" }}>
        <svg xmlns="" viewBox="0 0 512 512" fill="#fff">
          <path d="M242 180.6v-138L0 256l242 213.4V331.2h270V180.6z" />
        </svg>
      </div>
    ),
    nextArrow: (
      <div style={{ width: "0", marginLeft: "0" }}>
        <svg xmlns="" viewBox="0 0 512 512" fill="#fff">
          <path d="M512 256L270 42.6v138.2H0v150.6h270v138z" />
        </svg>
      </div>
    ),
  };

  return (
    <div>
      <div className="slide-container">
        <div className="each-fade">
          <div>
            <img
              // src="https://cdn.pixabay.com/photo/2016/12/22/22/07/hands-1926414_960_720.jpg"
              src={require("../../assets/Home-assets/back1.jpg").default}
              alt=".."
            />
            <div className="home-page-text">
              <img
                style={{
                  width: "130px",
                  height: "130px",
                  position: "relative",
                  bottom: "100px",
                  cursor: "pointer"
                }}
                href="#"
                src={require("../../assets/pixala clikd(1).png").default}
              />
              <p>Welcome to</p>
              <p className="middle__header">Pixala Clikd</p>
              <p className="typewriter">Enhanced in Each Perception.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Fade Carousel */}

      {/* <div className="slide-container">
        <Fade {...properties}>
          <div className="each-fade">
            <div>
              <img src={require("../../assets/slidy-1.jpg").default} />
            </div>
          </div>
          <div className="each-fade">
            <div>
              <img src={require("../../assets/slidy-2.jpeg").default} />
            </div>
          </div>
          <div className="each-fade">
            <div>
              <img src={require("../../assets/slidy-1.jpg").default} />
            </div>
          </div>
        </Fade>
      </div> */}

      {/* Video fro Home Page */}

      {/* <div className="hero-container">
        <video
          src={require("../../assets/photography.mp4").default}
          autoPlay
          loop
          muted="true"
        />
      </div> */}
    </div>
  );
};

export default FadeExample;
